import { ProtocolImage } from '@/components/common/protocolImage'
import { TokenImage } from '@/components/common/tokenImage'
import { cn } from '@/utils/cn'
import type { BorrowMarket } from '@/utils/internalAppSdk'
import type { ComponentProps } from 'react'

interface Props {
  marketName: string
  assetSymbol: string
  protocol: BorrowMarket['protocol']
}

export const BorrowMarketHeader = ({
  marketName,
  assetSymbol,
  protocol,
  className,
  ...props
}: Props & ComponentProps<'header'>) => (
  <header className={cn('flex max-w-full flex-wrap items-center gap-2 overflow-hidden md:gap-4', className)} {...props}>
    <div className="flex max-w-full items-center gap-2 overflow-hidden md:gap-4">
      <ProtocolImage protocol={protocol} className={cn('size-6 p-0.5', 'md:size-8', 'lg:size-10')} />
      <h1
        className="max-w-full truncate font-medium text-2xl text-heading-foreground lg:text-[28px]"
        title={marketName}
      >
        {marketName}
      </h1>
    </div>
    <div className="flex max-w-full items-center gap-2 overflow-hidden md:gap-4">
      <div className="flex h-8 items-center gap-1 rounded-full border bg-page px-2">
        <span className="text-sm">Borrow</span>
        <TokenImage symbol={assetSymbol} className="size-6" />
        <span className="text-sm">{assetSymbol}</span>
      </div>
    </div>
  </header>
)
